(function() {
  if (window.__vgNewsletterInit) return;
  window.__vgNewsletterInit = true;

  var KLAVIYO_COMPANY = 'WjG3kr';

  function bindForms() {
    document.querySelectorAll('[data-vg-newsletter]').forEach(function(form) {
      if (form.__vgBound) return;
      form.__vgBound = true;

      var sectionId = form.getAttribute('data-vg-newsletter');
      var success = document.getElementById('vg-nl-success-' + sectionId);
      var listId = form.getAttribute('data-klaviyo-list');
      if (!success) return;

      form.addEventListener('submit', function(e) {
        if (!listId) return;

        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value : '';
        var btn = form.querySelector('button[type="submit"]');

        if (!email) return;
        var btnLabel = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '...'; }

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                },
                custom_source: 'Veggiet Website Newsletter'
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        })
        .then(function(res) {
          if (res.ok || res.status === 202) {
            form.style.display = 'none';
            success.style.display = 'flex';

            if (typeof fbq === 'function') {
              fbq('track', 'Lead', {
                content_name: 'newsletter_signup',
                content_category: 'email_capture',
                value: 0,
                currency: 'CAD'
              });
            }
          } else {
            return res.text().then(function(t) { throw new Error(t); });
          }
        })
        .catch(function(err) {
          /* 2026-09-29: never show success when the signup failed — keep the form and say so */
          console.error('Klaviyo subscribe error:', err);
          if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
          var msg = form.querySelector('.vg-nl__error');
          if (!msg) { msg = document.createElement('p'); msg.className = 'vg-nl__error'; msg.setAttribute('role', 'alert'); form.appendChild(msg); }
          msg.textContent = 'Something went wrong. Please try again in a moment.';
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }
})();
